import React from 'react'
import classNames from 'classnames'
import pretty from '@st-operations/uikit/lib/pretty'

// also used for destinations change request
const ContentRuleChangeRequestStatusBadge = ({ status }) => {
  return (
    <div
      className={classNames('rounded-md p-1 px-2 w-fit font-semibold text-sm', {
        'bg-primary text-gray-100': status === 'applied',
        'bg-secondary-100 text-primary': status === 'approved',
        'bg-[transparent] text-gray-400 border border-solid border-gray-400': status === 'pending',
        'bg-[transparent] text-red-400 border border-solid border-red-400': status === 'rejected',
      })}
    >
      {pretty(status)}
    </div>
  )
}

export default ContentRuleChangeRequestStatusBadge
